const getTableRoot = (node) => {
  const element =
    node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
  return (
    element?.closest(".el-table") ||
    element?.closest(".vxe-table") ||
    element?.closest("table")
  );
};

const getTableSelectors = (tableRoot) => {
  if (tableRoot.classList.contains("el-table")) {
    return {
      row: ".el-table__body-wrapper .el-table__row",
      cell: "td.el-table__cell",
    };
  }

  if (tableRoot.classList.contains("vxe-table")) {
    return {
      row: ".vxe-table--body-wrapper .vxe-body--row",
      cell: ".vxe-body--column",
    };
  }

  return {
    row: "tbody tr",
    cell: "td, th",
  };
};

const getSelectedTableRoots = (range) =>
  Array.from(document.querySelectorAll(".el-table, .vxe-table, table")).filter(
    (tableRoot) => {
      const componentTable = tableRoot.closest(".el-table, .vxe-table");
      const isInnerTable =
        tableRoot.matches("table") && componentTable !== null;
      return !isInnerTable && range.intersectsNode(tableRoot);
    },
  );

const getCellText = (cell) =>
  cell.innerText.replace(/\s+/g, " ").trim();

const handleCopy = (event) => {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed || !selection.rangeCount) {
    return;
  }

  const range = selection.getRangeAt(0);
  const copiedRows = getSelectedTableRoots(range).flatMap((tableRoot) => {
    const selectors = getTableSelectors(tableRoot);
    return Array.from(tableRoot.querySelectorAll(selectors.row))
      .filter(
        (row) =>
          getTableRoot(row) === tableRoot && range.intersectsNode(row),
      )
      .map((row) =>
        Array.from(row.querySelectorAll(selectors.cell))
          .filter(
            (cell) =>
              getTableRoot(cell) === tableRoot &&
              range.intersectsNode(cell),
          )
          .map(getCellText)
          .filter(Boolean)
          .join("  "),
      )
      .filter(Boolean);
  });

  if (!copiedRows.length) {
    return;
  }

  event.preventDefault();
  event.clipboardData?.setData("text/plain", copiedRows.join("\n"));
};

export const initTableCopy = () => {
  document.addEventListener("copy", handleCopy);
};
